module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-chatbot-555d98c9bdecff10d674fd7a42a2df0c.gif";